export default __webpack_public_path__ + "static/media/photo--lg--58.c0a8d4b6.jpg";